type Props = {
  /** The documents that mention the entity (`FlowNodeData.mentions`); nothing shows when absent or 0. */
  count: number | undefined;
};

const documents = (count: number, one: string, many: string) =>
  `${count.toLocaleString('en-US')} ${count === 1 ? one : many}`;

/**
 * A small muted count at the right end of an entity card's line, e.g. `12 docs`: the number the sidebar's
 * "Mentioned by N documents" shows. One text-xs line high, so the card keeps its slot height. Hidden with the
 * card's other detail at title-only zoom (`data-detail`, see NodeShell).
 */
export function MentionCount({ count }: Props) {
  if (!count) return null;
  return (
    <span
      data-detail
      title={`Mentioned by ${documents(count, 'document', 'documents')}`}
      className="ml-auto shrink-0 rounded-sm bg-zinc-100 px-1 text-xs/4 whitespace-nowrap text-gray-500 tabular-nums dark:bg-white/5 dark:text-zinc-400"
    >
      {documents(count, 'doc', 'docs')}
    </span>
  );
}
